export default function appendFields(
  data: any[],
  appended: { [key: string]: any },
) {
  return data.map((item) => ({ ...item, ...appended }));
}
